module.exports = __webpack_public_path__ + "static/img/dszy.fb4f6e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CCT004/dszy.png
// module id = h8Gk
// module chunks = 1